import {
    MessageFieldsFragment,
    namedOperations,
    useWritebackChatMutation,
} from '~graphql/generated/graphql'
import { useToastFeedback } from '~utils/hooks/use-toast-feedback'

export function useWritebackMessages() {
    const toasts = useToastFeedback(
        'Successfully saved message to PIMS!',
        'Error saving message to PIMS',
    )

    const [writebackChatMutation, { loading }] = useWritebackChatMutation()

    const writebackMessage = async (
        chatId: string,
        messages: Pick<MessageFieldsFragment, 'id'>[],
        // patientId?: string,
    ) => {
        const messageIds = messages.map(m => m.id)

        await writebackChatMutation({
            variables: {
                chatId,
                messageIds,
                isManualWriteback: true,
            },
            refetchQueries: [namedOperations.Query.getMessagesByChatId],
            onCompleted: toasts.onCompleted,
            onError: error => toasts.onError(error.message),
        })
    }

    return [writebackMessage, { loading }] as const
}
